module.exports = __webpack_public_path__ + "img/wolfgang-hasselmann-J-Hv3jFsMZ8-unsplash.ff1552c0.jpeg";